import { render, staticRenderFns } from "./ProductQuantity.vue?vue&type=template&id=623af5d2"
import script from "./ProductQuantity.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductQuantity.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports